import { useEffect, useRef } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { BsArrowRightShort } from "react-icons/bs";

export const SiteDevelopmentViewMain = () => {

    const sectionRef = useRef(null);
    const gridRef = useRef(null);

    useEffect(() => {
        const section = sectionRef.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    section.classList.add("visible");
                }
            },
            { threshold: 0.3 }
        );

        if (section) observer.observe(section);
        return () => { if (section) observer.unobserve(section); };
    }, []);

    useEffect(() => {
        const handleMouseMove = (e) => {
            const grid = gridRef.current;
            if (!grid) return;

            const { clientX, clientY } = e;
            const x = (clientX / window.innerWidth - 0.5) * 10;
            const y = (clientY / window.innerHeight - 0.5) * 10;

            grid.style.transform = `perspective(1000px) rotateX(${-y}deg) rotateY(${x}deg)`;
        };

        window.addEventListener("mousemove", handleMouseMove);
        return () => window.removeEventListener("mousemove", handleMouseMove);
    }, []);


    const handleClick = () => {
        // Forzamos la URL oficial de Loopy Studios
        window.open("https://loopy-studios.com/", '_blank', 'noopener,noreferrer');
    };

    return (
        <section id="contact" ref={sectionRef} className="site-development-section">
            <div className="site-development-grid-bg" ref={gridRef}>
                <div className="node h"></div>
                <div className="node h"></div>
                <div className="node h"></div>
                <div className="node h"></div>
                <div className="node h"></div>

                <div className="node v"></div>
                <div className="node v"></div>
                <div className="node v"></div>
                <div className="node v"></div>
                <div className="node v"></div>
            </div>

            <div className="site-development-container">
                <div style={{ textAlign: "center" }}>
                    <div className="site-development-text">
                        <h2 className="section-title">
                            SITIO EN DESARROLLO POR <br /> <span>LOOPY STUDIOS</span>
                        </h2>

                        <div className="success-message">
                            <div className="success-icon">
                                <svg class="infinity-loader" viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg">
                                    <path className="infinity-path"
                                        d="M 20,25 C 20,10 40,10 50,25 C 60,40 80,40 80,25 C 80,10 60,10 50,25 C 40,40 20,40 20,25 Z"
                                        stroke="#00d748" stroke-width="6" fill="none"
                                        stroke-linecap="round" />
                                </svg>
                            </div>
                            <div className="back-action-container">
                                <p className="back-command_current">
                                    <BsArrowRightShort size={24} style={{ color: "#00d748" }} />
                                    <span className="command-text">
                                        {`https://${window.location.host}/`}
                                    </span>  <span className="cursor-blink">_</span>
                                </p>
                                <p className="back-command" onClick={handleClick} style={{ cursor: 'pointer' }}>
                                    <FaExternalLinkAlt size={24} />
                                    <span className="command-text">
                                        {"https://loopy-studios.com/"}
                                    </span>
                                    <span className="cursor-blink">_</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};